var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon06({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    overflow: "hidden",
    preserveAspectRatio: "xMidYMid meet",
    id: "eaf-764e-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eaf-764e-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eaf-764e-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 0l12 0c1.6554 0 3 1.3446 3 3l0 14c0 1.6554 -1.3446 3 -3 3l-12 0c-1.6554 0 -3 -1.3446 -3 -3l0 -14c0 -1.6554 1.3446 -3 3 -3z",
    clipRule: "evenodd",
    transform: "translate(3 2)"
  })), /*#__PURE__*/React.createElement("style", null, "#eaf-764e-0 * {animation: 1500ms linear infinite normal both running;offset-rotate:0deg}@keyframes eaf-764e-3{0%{animation-timing-function:step-start}21.13%{d:path(\"m7 15l10 0m-10 3l6 0m-2.9489 -10.4801l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z\");animation-timing-function:cubic-bezier(0,0,0.58,1)}33.33%{d:path(\"m7 16.3172l10 0m-10 2.2167l6 0m-2.9489 -8.5909l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z\")}37.8%{d:path(\"m7 16.3172l10 0m-10 2.2167l6 0m-2.9489 -8.5909l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z\");animation-timing-function:cubic-bezier(0,0,0.58,1)}50%{d:path(\"m7 -2.6828l10 0m-10 2.2167l6 0m-2.9489 -8.5909l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z\");animation-timing-function:cubic-bezier(0,0,0.58,1)}56.67%{d:path(\"m7 -4.4285l10 0m-10 4.1468l6 0m-2.9489 -12.243l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z\")}57.8%{d:path(\"m7 33.3639l10 0m-10 3l6 0m-2.9489 -10.4801l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z\")}62.2%{d:path(\"m7 33.3639l10 0m-10 3l6 0m-2.9489 -10.4801l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z\");animation-timing-function:cubic-bezier(0,0,0.58,1)}74.47%{d:path(\"m7 12.6908l10 0m-10 3.4084l6 0m-2.9489 -11.3038l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z\");animation-timing-function:cubic-bezier(0,0,0.58,1)}82.2%,100%{d:path(\"m7 15l10 0m-10 3l6 0m-2.9489 -10.4801l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z\")}}"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url('#eaf-764e-1')",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url('#eaf-764e-2')"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7 15l10 0m-10 3l6 0m-2.9489 -10.4801l-2.3669 -0.504l1.5464 4.2063l6.4433 -1.1923l0.0104 -4.6035l-2.1144 1.3763l-2.0828 -1.8027l-1.4359 2.5199z",
    transform: "translate(-0.3975 0.5)",
    style: {
      animationName: "eaf-764e-3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21 6l0 12c0 0.3453 0 0.6804 0 1c0 1.6569 -1.3431 3 -3 3l-12 0c-1.6568 0 -3 -1.3431 -3 -3c0 -0.3196 0 -0.6547 0 -1l0 -12c0 -0.3453 0 -0.6804 0 -1c0 -1.6569 1.3432 -3 3 -3l12 0c1.6569 0 3 1.3431 3 3c0 0.3196 0 0.6547 0 1z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon06.3259d6827ff5d1d2679077740cfd6f32.svg";
export { ForwardRef as ReactComponent };